import InfoCallout from "@components/common/info/InfoCallout";
import { DSCardWrapper } from "@components/design-system/molecules";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import AddUsersTable from "./AddUsersTable";

const ConfirmNewUsers = ({
  newUsers = [],
  existingUsers = [],
  deactivatedUsers = [],
  setUsersState,
  updateUsersAndBillingText,
  orgAllowsDirectMemberAdd,
  orgIsManualBilling,
  error,
  billingIncrementText,
  hasBillingSetup,
  onboardingMode = false,
}) => {
  const [newUsersState, setNewUsersState] = useState(newUsers);
  const [existingUsersState, setExistingUsersState] =
    useState(existingUsers);

  useEffect(() => {
    if (setUsersState) {
      setUsersState({
        newUsers: newUsersState,
        existingUsers: existingUsersState,
      });
    }
  }, [newUsersState, existingUsersState, setUsersState]);

  const emptyTeam =
    newUsersState.length === 0 &&
    existingUsersState.length === 0 &&
    deactivatedUsers.length === 0;

  return (
    <>
      {!emptyTeam && (
        <InfoCallout>
          Set a role that reflects the team member's role in your
          clinic. Setting a user as an admin will allow them to manage
          your team members and billing. We recommend only setting a
          member as an admin if necessary.
        </InfoCallout>
      )}

      {newUsersState.length > 0 && (
        <div
          className={`${
            onboardingMode
              ? "bg-transparent border border-transparent"
              : "bg-secondary border border-primary"
          } rounded-standard py-sm px-sm w-full my-md`}
        >
          <h5
            className={`${
              onboardingMode ? "text-white" : ""
            } font-bold text-lg mb-2`}
          >
            New Scribenote Users
          </h5>
          <AddUsersTable
            users={newUsersState}
            isExisting={false}
            setUsers={setNewUsersState}
            updateUsersAndBillingText={updateUsersAndBillingText}
            error={error}
            hasBillingSetup={hasBillingSetup}
            orgAllowsDirectMemberAdd={orgAllowsDirectMemberAdd}
            orgIsManualBilling={orgIsManualBilling}
            onboardingMode={onboardingMode}
          />
        </div>
      )}
      {existingUsersState.length > 0 && (
        <div
          className={`${
            onboardingMode
              ? "bg-transparent border border-transparent"
              : "bg-secondary border border-primary"
          } rounded-standard py-sm px-sm w-full my-md`}
        >
          <h5
            className={`${
              onboardingMode ? "text-white" : ""
            } font-bold text-lg mb-2`}
          >
            Existing Scribenote Users
          </h5>
          <AddUsersTable
            users={existingUsersState}
            isExisting={true}
            setUsers={setExistingUsersState}
            updateUsersAndBillingText={updateUsersAndBillingText}
            error={error}
            hasBillingSetup={hasBillingSetup}
            orgAllowsDirectMemberAdd={orgAllowsDirectMemberAdd}
            orgIsManualBilling={orgIsManualBilling}
            onboardingMode={onboardingMode}
          />
        </div>
      )}
      {deactivatedUsers.length > 0 && (
        <p>
          User{deactivatedUsers.length > 1 ? "s" : ""}{" "}
          {deactivatedUsers.map((user, index) => (
            <span key={index}>
              {user}
              {index < deactivatedUsers.length - 1 ? ", " : ""}
            </span>
          ))}{" "}
          {deactivatedUsers.length > 1 ? "are" : "is"} deactivated and
          therefore cannot be added. Please contact customer support
          to reinstate any accounts.
        </p>
      )}
      {existingUsersState.length === 0 &&
        newUsersState.length === 0 &&
        deactivatedUsers.length === 0 && (
          <h5
            className={`text-center ${
              onboardingMode && "text-white"
            }`}
          >
            Your team has been created without any of your teammates.
            Please remember that you can invite your team members
            later!
          </h5>
        )}

      {!orgIsManualBilling && billingIncrementText && (
        <div className="mt-md">
          <DSCardWrapper
            variant="info"
            padding="px-lg py-6"
            dataTestId="billing-info-callout"
          >
            <div className="flex flex-row items-center text-brand text-xs">
              <FontAwesomeIcon
                icon={faInfoCircle}
                size="2x"
                className="mr-4"
              />
              <div>{billingIncrementText}</div>
            </div>
          </DSCardWrapper>
        </div>
      )}
    </>
  );
};

export default ConfirmNewUsers;
